export default __webpack_public_path__ + "static/media/paso6-icon.437dcf68.svg";